export const ONE_DAY_IN_MILLISECONDS = 86400000;

export type GenericSelectOption = { label?: string; value: string; translatedLabel?: string };

export const THREE_SECONDS_AUTO_CLOSE_TOAST = 3000;

export const ENVIRONMENT_PRODUCTION = 'production';
export const ENVIRONMENT_STAGING = 'staging';

export const SORTING_TYPE_DOCUMENT_NAME_ASC = 'name_asc';
export const SORTING_TYPE_DOCUMENT_DATE_ASC = 'date_asc';
export const SORTING_TYPE_DOCUMENT_DATE_DESC = 'date_desc';
export const SORTING_TYPE_DOCUMENT_UNMATCHED = 'unmatched';

export const FIRST_DAY_OF_MONTH = 1;
export const CURRENT_YEAR = new Date().getFullYear();
export const CURRENT_MONTH = new Date().getMonth();

export const STRICT_EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
